import * as React from "react";
const ExcalimIcon = (props: any) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 4.84375V8.125"
      stroke="#6D77A0"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1751 5.36252V9.6375C13.1751 10.3375 12.8001 10.9875 12.1939 11.3438L8.48137 13.4875C7.87512 13.8375 7.1251 13.8375 6.5126 13.4875L2.8001 11.3438C2.19385 10.9938 1.81885 10.3438 1.81885 9.6375V5.36252C1.81885 4.66252 2.19385 4.0125 2.8001 3.65625L6.5126 1.5125C7.11885 1.1625 7.86887 1.1625 8.48137 1.5125L12.1939 3.65625C12.8001 4.0125 13.1751 4.65627 13.1751 5.36252Z"
      stroke="#6D77A0"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 10.125V10.1875"
      stroke="#6D77A0"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ExcalimIcon;
